import { registerComponent } from '@gig/magic-common';
import SwitchComponent from './switch.vue.js';

var Switch = registerComponent(SwitchComponent);

export { Switch };
